import { callStateAtom } from "@/Components/VideoRooms/VideoParts/videoAtoms";
import { CallState } from "@/types/callState";
import classNames from "@/utils/classNames";
import { useMediaQuery } from "@react-hook/media-query";
import axios from "axios";
import { getDefaultStore } from "jotai";
import { useState } from "react";
import { createRoot } from "react-dom/client";
import { FaXmark } from "react-icons/fa6";

let version = null;
let forceReloadToken = null;
const pageDataStr = document
    .querySelector("[data-page]")
    ?.getAttribute("data-page");
if (pageDataStr) {
    const pageData = JSON.parse(pageDataStr);
    version = pageData.version;
    forceReloadToken = pageData.props?.forceReloadToken;
}

const updatePromptRoot = document.createElement("div");
updatePromptRoot.id = "update-prompt-root";
document.body.appendChild(updatePromptRoot);
const reactRoot = createRoot(updatePromptRoot);
let hasRendered = false;

axios.interceptors.response.use((response) => {
    const newAppVersion = response.headers?.["x-app-version"];
    const newForceReloadToken = response.headers?.["x-force-reload-token"];
    const callState = getDefaultStore().get(callStateAtom);
    const isInSession = callState !== CallState.Closed;

    if (isInSession) {
        return response;
    }

    if (
        forceReloadToken &&
        newForceReloadToken &&
        forceReloadToken !== newForceReloadToken
    ) {
        location.reload();
    } else if (newAppVersion && newAppVersion !== version && !hasRendered) {
        hasRendered = true;
        reactRoot.render(<UpdatePrompt />);
        setTimeout(
            () => location.reload(), // You got your chance, now we force reload your page
            1_000 * 60 * 60 * 4,
        );
    }
    return response;
});

export default function UpdatePrompt() {
    const isSmall = useMediaQuery("(max-width: 1024px)");

    const [isPromptVisible, setIsPromptVisible] = useState(true);

    const hidePrompt = () => {
        setIsPromptVisible(false);
        setTimeout(
            () => {
                setIsPromptVisible(true);
            },
            1_000 * 60 * 60,
        );
    };

    return isPromptVisible ? (
        <div
            data-testid="prompt-update-reload-modal"
            className={classNames(
                "fixed right-0 m-8",
                isSmall ? "top-0" : "bottom-0",
            )}
            style={{ zIndex: 1000000 }}
        >
            <div
                data-testid="close-button"
                className="absolute -right-2 -top-2 cursor-pointer rounded-full border-2 border-brand-black bg-brand-white hover:bg-brand-gray hover:text-brand-white"
                onClick={() => hidePrompt()}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        hidePrompt();
                    }
                }}
                role="button"
                tabIndex={0}
                aria-label="Close notification"
            >
                <FaXmark className="text-md" />
            </div>
            <div className="flex items-center rounded-lg bg-brand-white p-4 shadow-lg">
                <div className="max-w-sm text-sm">
                    A new version of this page is available.{" "}
                    <span
                        className="cursor-pointer underline hover:text-brand-red"
                        onClick={() => location.reload()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                location.reload();
                            }
                        }}
                        role="button"
                        tabIndex={0}
                    >
                        Refresh page
                    </span>
                </div>
            </div>
        </div>
    ) : null;
}
